import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconLink';
/** Renders an SVG icon. */
const SvgLink = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6 12a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4.146a2 2 0 0 0 1.789-1.106l.17-.341a1 1 0 1 1 1.79.894l-.171.342A4 4 0 0 1 10.146 22H6a4 4 0 0 1-4-4v-4a4 4 0 0 1 4-4h4.146a4 4 0 0 1 3.578 2.211l.17.342a1 1 0 1 1-1.788.894l-.171-.341A2 2 0 0 0 10.145 12zm12.276.211A4 4 0 0 1 21.854 10H26a4 4 0 0 1 4 4v4a4 4 0 0 1-4 4h-4.146a4 4 0 0 1-3.578-2.211l-.17-.342a1 1 0 1 1 1.788-.894l.171.341A2 2 0 0 0 21.855 20H26a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-4.146a2 2 0 0 0-1.789 1.106l-.17.341a1 1 0 1 1-1.79-.894zM10 16a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H11a1 1 0 0 1-1-1"
      />
    </svg>
  );
};
SvgLink.displayName = displayName;
export default SvgLink;
